import React from 'react';
import { Box, VStack, Icon } from '@chakra-ui/react';
import { FiMail, FiPhone } from 'react-icons/fi';
import { LuMessageCircleQuestion } from 'react-icons/lu';
import { useTranslation } from '../../hooks/useTranslation';
import { useGetCustomerQuery } from '../../api';
import Button from '../../components/base/Button';
import LoadingState from '../../components/base/LoadingState';
import { useSupportEmail } from '../../hooks/useSupportEmail';
import ContactInfoItem from '../../components/support/ContactInfoItem';
import PageTitle from '../../components/base/PageTitle';

const SupportPage: React.FC = () => {
    const { t } = useTranslation();
    const { data: customer, isLoading } = useGetCustomerQuery();
    const { sendEmail } = useSupportEmail();

    const handleWriteToSupport = () => {
        sendEmail(t.pages.support.emailSubject);
    };

    if (isLoading || !customer) {
        return <LoadingState message={t.pages.support.loading} />;
    }

    return (
        <Box
            h="calc(100vh - 20px)"
            bg="gray.100"
            display="flex"
            alignItems="center"
            justifyContent="center"
            p={6}
            pb={{ base: 20, lg: 6 }}
            overflow="auto"
            w="full"
        >
            <Box maxW="4xl" w="full">
                <VStack gap={6} align="stretch" pb={16}>
                    {/* Иконка поддержки и заголовок */}
                    <VStack gap={2} align="stretch">
                        <Box display="flex" justifyContent="center">
                            <Box display="flex" alignItems="center" justifyContent="center" w={20} h={20}>
                                <Icon as={LuMessageCircleQuestion} boxSize={12} color="yellow.600" />
                            </Box>
                        </Box>

                        {/* Заголовок */}
                        <PageTitle title={t.pages.support.title} size="2xl" />
                    </VStack>

                    {/* Телефон */}
                    <ContactInfoItem
                        icon={FiPhone}
                        label={t.pages.support.phone}
                        value={customer.support_phone}
                        href={`tel:${customer.support_phone.replace(/[^0-9+]/g, '')}`}
                        hint={t.pages.support.phoneHint}
                    />

                    {/* Email */}
                    <ContactInfoItem
                        icon={FiMail}
                        label={t.pages.support.email}
                        value={customer.support_email}
                        onClick={handleWriteToSupport}
                    />

                    {/* Кнопка написать в поддержку */}
                    <Box display="flex" justifyContent="center" mt={4}>
                        <Button buttonType="success" size="lg" onClick={handleWriteToSupport}>
                            {t.pages.support.writeButton}
                        </Button>
                    </Box>
                </VStack>
            </Box>
        </Box>
    );
};

export default SupportPage;
